import React from 'react';
import { Box, Typography } from '@mui/material';
import SelectWithSearch from 'src/components/SelectWithSearch/view';
import { CornerBadge } from './CornerBadge.styles';
import { pointerCursorSx } from '../../helpers';

interface KeywordsFieldProps {
  values: string[];
  onChange: (values: string[]) => void;
  visible: boolean;
  required: boolean;
  isSelected: boolean;
  onClick: () => void;
  label?: string;
  options?: Array<{ text: string; value: string }>;
}

export const KeywordsField: React.FC<KeywordsFieldProps> = ({
  values,
  onChange,
  visible,
  required,
  onClick,
  label,
  options = [],
}) => {

  const handleSelectChange = (
    _event: React.SyntheticEvent | undefined,
    items: { value: string; text: string }[],
  ) => {
    if (!visible) return;
    const selectedIds = items.map(item => item.value);
    onChange(selectedIds);
  };

  return (
    <Box
      onClick={onClick}
      position="relative"
      p={1}
      border={1}
      borderColor="divider"
      borderRadius={1}
      sx={{ cursor: 'pointer', opacity: visible ? 1 : 0.6 }}
    >
      {!visible && (
        <CornerBadge>HIDDEN</CornerBadge>
      )}
      <Typography variant="subtitle2" mb={1} color={visible ? 'inherit' : 'grey.500'}>
        {label || 'Keywords'} {required && <Box component="span" color="error.main">*</Box>}
      </Typography>
      <Box onClick={onClick} sx={pointerCursorSx}>
        <SelectWithSearch
          label=""
          placeholder="Select keywords"
          options={options.map(option => ({ ...option, isDisabled: true }))}
          values={values}
          disabled={false}
          handleSelectChange={handleSelectChange}
          style={{
            width: '100%',
            opacity: visible ? 1 : 0.7
          }}
        />
      </Box>
    </Box>
  );
};
